var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 49.8564C8.99987 50.0066 9.02981 50.1553 9.0881 50.294C9.14639 50.4327 9.23188 50.5588 9.33971 50.665C9.44754 50.7712 9.57557 50.8555 9.7165 50.9129C9.85743 50.9704 10.0085 51 10.161 51H43.839C43.9915 51 44.1426 50.9704 44.2835 50.9129C44.4244 50.8555 44.5525 50.7712 44.6603 50.665C44.7681 50.5588 44.8536 50.4327 44.9119 50.294C44.9702 50.1553 45.0001 50.0066 45 49.8564V12.7148L35.1292 3H10.161C10.0085 3 9.85743 3.02959 9.7165 3.08707C9.57557 3.14455 9.44754 3.2288 9.33971 3.335C9.23188 3.4412 9.14639 3.56727 9.0881 3.70601C9.02981 3.84474 8.99987 3.99342 9 4.14355V49.8564Z",
    fill: "#F4F3F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.015 13.016H36.1C35.8083 13.016 35.5285 12.9001 35.3222 12.6938C35.1159 12.4875 35 12.2077 35 11.916V3L45.015 13.016Z",
    fill: "#E0E0E0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3498 40.0961C21.1125 46.6517 28.9622 15.3415 23.0201 17.0691C16.8459 18.8644 36.4451 40.6421 38.8611 34.5035C41.1814 28.6027 13.607 33.5725 17.3498 40.0961Z",
    stroke: "#FF6242",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.865564a5.svg";
export { ForwardRef as ReactComponent };